var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column",attrs:{"fluid":""}},[_c('cider-card',{ref:"ciderCardRef",attrs:{"cider":_vm.cider,"full-content":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }